module.exports = __webpack_public_path__ + "static/media/icon-team-survey-progress-completed.8d8c998f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-team-survey-progress-completed.svg
// module id = 1852
// module chunks = 0